/** Built-in Question of the Day bank (keep in sync with apps/bot/utils/qotdDefaults.js). */
export const DEFAULT_QOTD_QUESTIONS = [
  // Everyday / getting to know you
  "What's one small thing that made you smile recently?",
  "If you could teleport anywhere right now, where would you go?",
  "What's your go-to comfort food?",
  "What song have you had stuck in your head lately?",
  "Coffee, tea, or something else entirely?",
  "What's a hobby you'd love to try but haven't yet?",
  "Early bird or night owl?",
  "What's the best advice you've ever received?",
  "If your week had a theme song, what would it be?",
  "What's a movie or show you can rewatch forever?",
  "Beach day, mountain trip, or city adventure?",
  "What's something you're looking forward to?",
  "Sweet, salty, or spicy?",
  "What's a skill you're weirdly good at?",
  "If you could have dinner with any fictional character, who would it be?",
  "What's your favorite way to unwind after a long day?",
  "Hot take: pineapple on pizza - yes or no?",
  "What's a book, game, or podcast you'd recommend to a friend?",
  "Summer, fall, winter, or spring - which is your season?",
  "What's the most underrated place in your city or town?",
  "If you could instantly master one instrument, which would you pick?",
  "What's a childhood snack you still love?",
  "Would you rather explore space or the deep ocean?",
  "What's one goal you're working on right now?",
  "Cats, dogs, or neither - what's your vibe?",
  "What's the best concert, event, or hangout you've been to?",
  "If you had a free afternoon with no plans, how would you spend it?",
  "What's a fashion trend you secretly miss?",
  "Breakfast for dinner - yay or nay?",
  "What's a random fact you know that surprises people?",
  "If you could live in any video game world, which one?",
  "What's your favorite rainy-day activity?",
  "Texting or calling?",
  "What's something that always cheers you up?",
  "If you opened a tiny shop, what would you sell?",
  "What's the last thing that made you laugh out loud?",
  "Board games, video games, or outdoor games?",
  "What's a place you've always wanted to visit?",
  "Would you rather have unlimited flights or unlimited meals out?",
  "What's your comfort show when you need background noise?",
  "If today needed a plot twist, what would you want it to be?",
  "What's a food you disliked as a kid but love now?",
  "Morning workout or evening workout?",
  "What's a compliment you still remember?",
  "If you could pause time for one day, what would you do?",
  "What's your favorite season for fashion?",
  "Road trip playlist: throwbacks or new music?",
  "What's something you're proud of this month?",
  "Would you rather always be slightly too hot or slightly too cold?",
  "What's a simple pleasure you never get tired of?",
  "If your pet (or dream pet) could talk, what's the first question you'd ask?",
  "What's a tradition you want to start or keep?",
  "Silent library energy or busy café energy?",
  "What's the best gift you've ever given or received?",
  "If you could learn any language overnight, which one?",
  "What's your ideal weekend morning?",
  "Pizza night or taco night?",
  "What's a myth or rumor about you that's completely wrong?",
  "Would you rather have a personal chef or a personal chauffeur?",
  "What's a small habit that improved your life?",

  // More food & everyday picks
  "What's your order at a coffee shop?",
  "Soup or salad?",
  "What's the best meal you've cooked (or attempted)?",
  "Ice cream flavor you'd defend forever?",
  "Do you meal-prep or vibe-cook?",
  "What's a restaurant you'd recommend to a visitor?",
  "Brinner (breakfast for dinner) ranking: pancakes, waffles, or eggs?",
  "What's your comfort drink when you're sick?",
  "Spicy food: bring it on or absolutely not?",
  "What's a snack that disappears too fast in your house?",

  // Media & fandoms
  "What are you watching, reading, or playing right now?",
  "Favorite villain, antihero, or chaotic character?",
  "Opening credits: sit through them or skip?",
  "What's a soundtrack that hits every time?",
  "Animated movie you could quote from memory?",
  "What's your comfort YouTube / TikTok niche?",
  "Sequel, reboot, or original only?",
  "What's a game you keep meaning to finish?",
  "Favorite fictional friendship or found family?",
  "If your life was a genre, what would it be?",
  "What's an underrated show more people should watch?",
  "Comic books, novels, or short stories?",
  "What's your most-replayed song of the year?",
  "Horror movie night: yes, maybe, or never?",
  "What's a fandom you're quietly in?",

  // Would you rather / this or that
  "Would you rather have a rewind button or a pause button for life?",
  "Would you rather be able to fly or be invisible?",
  "Would you rather never use social media again or never watch TV/movies again?",
  "Would you rather always know when someone is lying or always get away with lying?",
  "Mountains for a week or beach for a weekend?",
  "Group hang or one-on-one time?",
  "Plan every detail or show up and figure it out?",
  "Would you rather have super strength or super speed?",
  "Staycation or spontaneous trip?",
  "Would you rather lose your phone for a week or your headphones?",
  "Sunrise hike or midnight drive?",
  "Would you rather cook every meal or never cook again (but eat mystery food)?",

  // Memories & stories
  "What's your favorite childhood memory?",
  "What's the funniest thing that's happened to you recently?",
  "What's a trip you'll never forget?",
  "Describe your most chaotic school or work story.",
  "What's something you collected as a kid?",
  "What's the best birthday you've had?",
  "What's a nickname you've had and how did you get it?",
  "What's the bravest thing you've done?",
  "What's a coincidence that still feels unreal?",
  "What's a skill you learned the hard way?",
  "What's your earliest music memory?",
  "What's a place that feels like home (that isn't home)?",

  // Dreams & hypotheticals
  "If you won a free class in anything, what would you take?",
  "If you could guest-star in any show, which one?",
  "If you had a theme park ride named after you, what would it be like?",
  "If you could time-travel once, past or future — and why?",
  "If you designed a holiday, what would people celebrate?",
  "If you could swap lives with someone for a day, who?",
  "If your dream job had no barriers, what would it be?",
  "If you wrote a memoir title today, what would it be?",
  "If you could master any sport overnight, which one?",
  "If money wasn't a factor, where would you live?",
  "If you had a signature scent / candle, what would it smell like?",
  "If you could add one room to your home, what would it be?",

  // Personality & preferences
  "Introvert battery: social plans fill you up or drain you?",
  "What's your go-to karaoke song (even if you'd never sing it)?",
  "Are you more of a planner sticker-sheet person or a sticky-note chaos person?",
  "What's your desktop / lock screen vibe?",
  "Do you read instructions first or figure it out as you go?",
  "What's your most-used emoji?",
  "Clean aesthetic or cozy clutter?",
  "What's a hill you'll die on?",
  "Are you team window seat or aisle seat?",
  "What's your typing style: essays, voice notes, or one-liners?",
  "Do you keep old texts / photos forever or declutter often?",
  "What's your comfort hoodie / fit?",
  "Are you usually early, on time, or fashionably late?",
  "What's something you're surprisingly competitive about?",

  // Soft / reflective
  "What's a kindness someone showed you that stuck with you?",
  "What's something you're learning about yourself lately?",
  "Who in your life makes ordinary days better?",
  "What's a boundary you're glad you set?",
  "What's a win from this week, big or tiny?",
  "What does a \"good day\" look like for you?",
  "What's something you want to be known for?",
  "What's a fear you've gotten better at facing?",
  "What's a piece of media that changed how you see things?",
  "What are you grateful for today?",
  "What's a goal that excites you more than it scares you?",
  "What's something you hope next month brings?",

  // Server / community-friendly
  "If this server was a hangout spot IRL, what would it look like?",
  "What's your Discord status energy most days?",
  "Late-night chats or daytime banter?",
  "What's a channel here you lurk in the most?",
  "If you made a server emoji, what would it be?",
  "What's your favorite way people say hi here?",
  "Voice chat: hop in often, sometimes, or text-only legend?",
  "What brought you to this community?",
  "If the server had a mascot, what should it be?",
  "What's something wholesome you've seen online lately?",

  // Fun chaos
  "What's the most unhinged google search you've made?",
  "Conspiracy theory you'd pretend to believe for fun?",
  "What's a weird talent you have?",
  "If aliens landed tomorrow, what's your first move?",
  "What's your villain origin story (petty version)?",
  "Describe your sleep schedule using only vibes.",
  "What's a product that feels like a scam but you still buy?",
  "If your browser history became public, how cooked are you?",
  "What's the pettiest reason you've ended an argument?",
  "Rank your chaos level today from 1–10.",
  "What's a hill you're willing to die on that's objectively silly?",
  "If your life had loading screen tips, what's one of them?",

  // Nature & places
  "Favorite weather for a walk?",
  "Camping: tent, cabin, or hotel with \"outdoors vibes\"?",
  "What's a smell that instantly takes you somewhere?",
  "City lights or starry sky?",
  "What's your favorite houseplant (real or imaginary)?",
  "Ocean, lake, or pool?",
  "What's a scenic drive or route you love?",
  "Do you notice sunsets, or do they sneak up on you?",

  // Work / school / routines (light)
  "What's your ideal work-from-anywhere setup?",
  "Productivity hack that actually works for you?",
  "What's your favorite break-time ritual?",
  "Noise: silence, lo-fi, or full playlist?",
  "What's a tool or app you couldn't work without?",
  "Monday energy or Friday energy — which are you stuck with today?",

  // Creative prompts
  "If you started a podcast, what would it be about?",
  "What's a story idea you've never written down?",
  "Describe your aesthetic in three words.",
  "If you designed a sneaker or jacket, what would it look like?",
  "What's a creative project you abandoned and might restart?",
  "Collage, sketch, write, or build — what's your creative default?",
  "If you curated a museum exhibit, what would it include?",

  // Seasonal / situational
  "What's your hot-weather survival strategy?",
  "Best cold-weather comfort combo (drink + activity)?",
  "What's a holiday tradition you'd steal from another culture or family?",
  "New Year energy: resolutions, vibes-only, or skip?",
  "What's your go-to outfit when you want to feel confident?",
  "Rainy day: book, game, or nap?",
];

export const QOTD_SOURCES = [
  { value: "default", label: "Default questions only" },
  { value: "custom", label: "Custom questions only" },
  { value: "both", label: "Custom + default questions" },
];

export function normalizeQotdSource(value) {
  const key = String(value || "").toLowerCase().trim();
  return QOTD_SOURCES.some((entry) => entry.value === key) ? key : "both";
}
